function useShowRawInformation(type, data, classname, message) {
    return <span className={classname} style={{ color : '#fd7723' }} >{message}</span>
}

export default useShowRawInformation;